module.exports = __webpack_public_path__ + "img/QRcode.a820436b.png";